var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5335 18.0016L24.1735 22.6404L22.6405 24.1733L18.0017 19.5334C16.2757 20.9171 14.1288 21.6697 11.9166 21.6665C6.53463 21.6665 2.16663 17.2985 2.16663 11.9165C2.16663 6.5345 6.53463 2.1665 11.9166 2.1665C17.2986 2.1665 21.6666 6.5345 21.6666 11.9165C21.6698 14.1287 20.9172 16.2756 19.5335 18.0016ZM17.3604 17.1978C18.7352 15.7839 19.5031 13.8886 19.5 11.9165C19.5 7.72617 16.1059 4.33317 11.9166 4.33317C7.72629 4.33317 4.33329 7.72617 4.33329 11.9165C4.33329 16.1058 7.72629 19.4998 11.9166 19.4998C13.8888 19.5029 15.784 18.7351 17.1979 17.3603L17.3604 17.1978Z",
    fill: "#818DAE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLine);
export default __webpack_public_path__ + "static/media/search-line.7849d703c158f503cfdb2c3e1f5be7bd.svg";
export { ForwardRef as ReactComponent };